"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
class Manager {
    constructor(bodyBuilder, sender) {
        this.prepareData = (queryParams) => this.bodyBuilder.prepare(queryParams);
        this.post = (endpoint, data, config) => this.sender.post({ endpoint, body: data, config });
        this.patch = (endpoint, data, config) => this.sender.patch({ endpoint, body: data, config });
        this.put = (endpoint, data, config) => this.sender.put({ endpoint, body: data, config });
        this.get = (endpoint, config) => this.sender.get({ endpoint, config });
        this.getFullResponse = (endpoint, config) => this.sender.getFullResponse({ endpoint, config });
        this.delete = (endpoint, data, config) => this.sender.delete({ endpoint, body: data, config });
        this.bodyBuilder = bodyBuilder;
        this.sender = sender;
    }
}
exports.default = Manager;
